module.exports = __webpack_public_path__ + "img/head_bg.0ac7c076.png";